import classNames from "classnames";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import Button, { ButtonWithPopover, defaultAnimationWithHidingSmooth } from "Components/button";
import CheckRadioButton from "Components/checkBoxRadio";
import { TextWidget } from "Components/optionForm";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { useMemo, useState } from "react";
import locale from "./sidebarSearchPanel.locale";
import styles from "./SidebarSearchPanel.module.css";
import { TbSortAscending, TbAdjustments } from "react-icons/tb";
const menuPosition = {
    my: "top right",
    at: "bottom right",
    collision: "fit flip",
    offset: { y: 2 }
};
const SIZES = {
    BUTTON_SIZE: 36
};
export default function SidebarSearchPanel(props) {
    const [activeButton, setActiveButton] = useState(false);
    const buttonSorting = useMemo(() => !isEmpty(props.availableSortBy) &&
        props.sortBy && (React.createElement(Button, { width: SIZES.BUTTON_SIZE, height: SIZES.BUTTON_SIZE, className: "no-border no-default-colors p-0", onClick: props.onToggleSortOrder },
        React.createElement("div", { className: styles["btn-settings"] },
            React.createElement(TbSortAscending, { className: props.sortOrder === SORT_ORDER.DESC ? "rotate-180" : "" })))), [props.availableSortBy, props.sortBy, props.sortOrder, props.onToggleSortOrder]);
    const buttonSettings = useMemo(() => !isEmpty(props.availableSortBy) && (React.createElement(ButtonWithPopover, { className: "no-border no-default-colors p-0", buttonWidth: SIZES.BUTTON_SIZE, buttonHeight: SIZES.BUTTON_SIZE, position: menuPosition, popoverClassName: "dark-popover1", animation: defaultAnimationWithHidingSmooth, onClose: () => {
            setActiveButton(false);
        }, onHidden: () => {
            setActiveButton(false);
        }, onClick: () => {
            setActiveButton(!activeButton);
        }, visible: activeButton, ignoreHidingWhenChanged: true, popoverContent: React.createElement("div", { className: "pt-0_5 pb-0_5" },
            React.createElement("div", { className: `${styles.title} line-height-1` }, locale.SORTING),
            React.createElement("div", { className: "mt-0_5" }, map(props.availableSortBy, (item, ind) => (React.createElement(CheckRadioButton, { key: item.Key, item: item, onCheckedChanged: () => {
                    props.onChangeSortBy && props.onChangeSortBy(item.Key);
                    setActiveButton(false);
                }, checked: props.sortBy === item.Key, className: classNames("font-small", ind !== 0 && "mt-0_25") }))))) },
        React.createElement("div", { className: `${styles["btn-settings"]} ${activeButton ? styles.active : ""}` },
            React.createElement(TbAdjustments, null)))), [props.availableSortBy, props.sortBy, props.onChangeSortBy, activeButton]);
    return (React.createElement("div", { className: classNames(props.className, buttonSorting && "grid-cols-1fr-auto with-gap-xxs v-center-items", "w-100", styles.container) },
        React.createElement(TextWidget, { className: props.searchClassName, mode: "search", value: props.filterText, showClearButton: false, placeholder: locale.FILTER_TEXT_PLACEHOLDER, onChange: props.onFilterTextChange, onEnterKey: props.onFilterTextEnterKey, stylingMode: "filled", height: 36 }),
        React.createElement("div", { className: styles["btn-group"] },
            buttonSorting,
            buttonSettings)));
}
